import { render } from "./LostPasswordPage.vue?vue&type=template&id=f44e1df6&scoped=true&ts=true"
import script from "./LostPasswordPage.vue?vue&type=script&lang=ts"
export * from "./LostPasswordPage.vue?vue&type=script&lang=ts"

import "./LostPasswordPage.vue?vue&type=style&index=0&id=f44e1df6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44e1df6"]])

export default __exports__